export interface StoreError {
  status: number;
  code: string;
  message: string;
}

export type Outcome<T> = { value: T } | { error: StoreError };

export function failure(status: number, code: string, message: string): { error: StoreError } {
  return { error: { status, code, message } };
}
